import axios from 'axios'
import store from '~/store'
import router from '~/router'
import swal from 'sweetalert2'
import i18n from '~/plugins/i18n'
import { ISecure } from '~/helpers/ISecure'

let isecure = new ISecure()

// Request interceptor
axios.interceptors.request.use(request => {
  const token = store.getters['auth/token']
  /* if (token) {

    request.headers.common['Authorization'] = `Bearer ${token}`
  } */

  const locale = store.getters['lang/locale']
  if (locale) {
    axios.defaults.headers.common['Accept-Language'] = locale
  }

  if (request.method != 'get') {
    if (token) {
      if (!request.data) {
        request.data = {
          token: token
        }
      } else {
        request.data.token = token
      }
    } else {
      if (!request.data) {
        request.data = 'dummy'
      }
    }
    console.log(request.data)
    isecure = new ISecure(JSON.stringify(request.data))
    request.data = {
      "payload": isecure.getEncryptData()
    }
  }


  // request.headers['X-Socket-Id'] = Echo.socketId()

  return request
})

// Response interceptor
axios.interceptors.response.use(
  response => {
    if (response.config.method != 'get') {
      let decrypt = {}
      decrypt = JSON.parse(isecure.getDecryptData(response.data.stringData))
      response.data = decrypt
      console.log(decrypt)
      return response
    } else {
      return response
    }
  }, error => {
    if (error.response.config.method != 'get') {
      let decrypt = {}
      decrypt = JSON.parse(isecure.getDecryptData(error.response.data.stringData))
      console.log(decrypt)
      error.response.data = decrypt
    }
    const { status } = error.response
    console.log(status)
    if (status >= 500) {
      swal({
        type: 'error',
        title: i18n.t('error_alert_title'),
        text: i18n.t('error_alert_text'),
        reverseButtons: true,
        confirmButtonText: i18n.t('ok'),
        cancelButtonText: i18n.t('cancel')
      })
    }

    if (status === 401 && store.getters['auth/check']) {
      swal({
        type: 'warning',
        title: i18n.t('token_expired_alert_title'),
        text: i18n.t('token_expired_alert_text'),
        reverseButtons: true,
        confirmButtonText: i18n.t('ok'),
        cancelButtonText: i18n.t('cancel')
      }).then(async () => {
        await store.dispatch('auth/logout')

        router.push({ name: 'login' })
      })
    }

    if (status === 401){
      swal({
        type: 'error',
        title: 'Security',
        text: 'Unauthorized.'
      })
      .then(async () => {
        router.push({ name: 'login' })
      }).catch(swal.noop)
    }

    return Promise.reject(error)
  }
)



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/axios.js